import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { usersList, roleList } from "constants/users";

//get user list
export const getUsersList = async (dispatch, pageNum,filters, searchString) => {
  try {
    const res = await api.users_list(pageNum, filters, searchString);
    dispatch({ type: usersList, payload: res.data });
  } catch (error) {
    dispatch({ type: usersList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

// add user
export const addUser = async (bodyData) => {
  try {
    const res = await api.add_user(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//get role list
export const getRoleList = async (dispatch) => {
  try {
    const res = await api.role_list();
    dispatch({ type: roleList, payload: res.data });
  } catch (error) {
    dispatch({ type: roleList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

//get user detail by id
export const getUserByID = async (id) => {
  try {
    const res = await api.get_user_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//edit user
export const editUser = async (id, bodyData) => {
  try {
    const res = await api.edit_user(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//change user password
export const changeUserPassword = async (id, bodyData) => {
  try {
    const res = await api.change_password(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
